/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Learnmoretitle2Inputs */

const zh_share_learnmoretitle2 = /** @type {(inputs: Share_Learnmoretitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`访问权限说明`)
};

const en_share_learnmoretitle2 = /** @type {(inputs: Share_Learnmoretitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access level details`)
};

const es_share_learnmoretitle2 = /** @type {(inputs: Share_Learnmoretitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles del nivel de acceso`)
};

/**
* | output |
* | --- |
* | "Access level details" |
*
* @param {Share_Learnmoretitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_learnmoretitle2 = /** @type {((inputs?: Share_Learnmoretitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Learnmoretitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_learnmoretitle2(inputs)
	if (locale === "en") return en_share_learnmoretitle2(inputs)
	return es_share_learnmoretitle2(inputs)
});
export { share_learnmoretitle2 as "share_learnMoreTitle" }